import { render, staticRenderFns } from "./attachmentEditor.vue?vue&type=template&id=6b5a733f&"
import script from "./attachmentEditor.vue?vue&type=script&lang=js&"
export * from "./attachmentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports